import { SettingOutlined } from '@ant-design/icons'
import {
  Button,
  Popconfirm,
  Popover,
  Space,
  TableColumnType,
  Tag,
  Tooltip,
} from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { ChangeLineFilled } from '../../compnents/icons/Icons'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { DateTimeFormatSimple } from '../../models/datetime'
import {
  getTenantCategoryName,
  getTeantTypeName,
  Tenant,
} from '../../models/tenant'
import { ThemeData } from '../../theme/ThemeContext'
import styles from './Tenants.module.css'

export const columns = (
  onClick: (
    type: 'settings' | 'toggle' | 'detail' | 'openReplaceMake',
    tenant: Tenant
  ) => void,
  startIndex: number,
  theme: ThemeData
): TableColumnType<Tenant>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构ID',
      key: 'id',
      align: 'center',
      width: '6rem',
      render: (_, t) => t.id?.split(' ')?.[0],
    },
    {
      title: '机构名称',
      key: 'name',
      align: 'center',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <Popover
            trigger='hover'
            placement='topLeft'
            content={
              <>
                <div
                  style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <i
                    style={{
                      width: 'auto',
                      height: '100%',
                      fontStyle: 'normal',
                      marginRight: '10px',
                    }}
                  >
                    {t.name}
                  </i>
                  {t?.trialFlag == 1 && (
                    <div
                      style={{
                        width: '24px',
                        height: '24px',
                        background: '#FF8345',
                        color: '#fff',
                        fontSize: '14px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      试
                    </div>
                  )}
                </div>
              </>
            }
          >
            <div
              style={{
                width: 220,
                margin: 'auto',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',

              }}
            >
              <span
                style={{
                  width: 'auto',
                  height: '100%',
                  fontStyle: 'normal',
                  marginRight: '10px',
                }}
              >
                {t.name} {t?.trialFlag == 1 && (
                  <span
                    style={{
                      width: '24px',
                      height: '24px',
                      background: '#FF8345',
                      color: '#fff',
                      fontSize: '14px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    试
                  </span>
                )}
              </span>

            </div>
          </Popover>
        )
      },
    },
    {
      title: '机构类别',
      key: 'tenantCategory',
      align: 'center',
      width: '5rem',
      render: (_, t) => getTenantCategoryName(t.tenantCategory),
    },
    {
      title: '机构类型',
      dataIndex: 'tenantType',
      key: 'tenantType',
      align: 'center',
      width: '5rem',
      ellipsis: true,
    },
    {
      title: '版本名称',
      key: 'versionName',
      dataIndex: 'versionName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <Space>
            {/* {t.labelList.map((item: any) => {
              return ( */}
            {/* <Tooltip
              placement='top'
              title={
                <>
                  <div>2023.08.09 口腔专业版</div>
                  <div>2023.08.09 中医专业版</div>
                </>
              }
            > */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px' }}>{t?.versionName}</span>
              {/* <ChangeLineFilled style={{ fontSize: '20px' }} /> */}
            </div>
            {/* </Tooltip> */}
            {/* )
            })} */}
          </Space>
        )
      },
    },
    {
      title: '标签',
      key: 'labelIds',
      align: 'center',
      render: function element(_, t) {
        return (
          <Space>
            {t.labelList.map((item: any) => {
              return (
                <Tooltip key={item.id} placement='top' title={item.name}>
                  <Tag
                    color={item.backgroundColor}
                    style={{ color: `${item.fontColor}` }}
                  >
                    {item.headName}
                  </Tag>
                </Tooltip>
              )
            })}
          </Space>
        )
      },
    },
    {
      title: '所属平台',
      align: 'center',
      dataIndex: 'platformName',
      ellipsis: true,
    },

    {
      title: '地址',
      key: 'address',
      align: 'left',
      ellipsis: true,
      dataIndex: 'address',
      // render: function Element(_, t) {
      //   return (
      //     <div
      //       // className={styles.title}
      //       style={{
      //         width: 220,
      //         overflow: 'hidden',
      //         whiteSpace: 'nowrap',
      //         textOverflow: 'ellipsis',
      //       }}
      //     >
      //       <i
      //         style={{
      //           width: 'auto',
      //           height: '100%',
      //           fontStyle: 'normal',
      //           marginRight: '16px',
      //         }}
      //       >
      //         {t.address}
      //       </i>
      //     </div>
      //   )
      // },
    },
    {
      title: '开通时间',
      key: 'createTime',
      align: 'center',
      width: '8rem',
      render: (_, t) => t.createTime?.split(' ')?.[0],
      sorter: true,
    },
    // {
    //   title: '登录时间',
    //   key: 'lastLoginTime',
    //   align: 'center',
    //   width: '8rem',
    //   render: (_, t) =>
    //     t.lastLoginTime
    //       ? moment(t.lastLoginTime).format(DateTimeFormatSimple)
    //       : '-',
    // },
    // {
    //   title: '起始时间',
    //   key: 'startTime',
    //   align: 'center',
    //   width: '8rem',
    //   render: (_, t) => t.startTime?.split(' ')?.[0],
    // },
    {
      title: '终止时间',
      key: 'endTime',
      align: 'center',
      width: '8rem',
      render: (_, t) => {
        return t.endTime?.split(' ')?.[0]
      },
      sorter: true,
      // sortOrder
    },
    {
      title: '服务状态',
      key: 'status',
      align: 'center',
      width: '8rem',
      render: function Status(_, t): ReactElement {
        const active = t.status === 1
        return (
          <Popconfirm
            title={active ? '是否确认注销' : '是否确认开启'}
            onConfirm={() => onClick('toggle', t)}
            okText='确认'
            cancelText='取消'
          >
            <div>
              <StateSwitch value={active} />
            </div>
          </Popconfirm>
        )
      },
      // render: (_, t) => t.status == 0 ? '停用' : '正常'
    },
    // {
    //   title: '代煎设置',
    //   key: 'status',
    //   align: 'center',
    //   width: '8rem',
    //   render: function ReplaceMake(_, t): ReactElement {
    //     return (
    //       <Button
    //         type='primary'
    //         style={{ width: 115, borderRadius: 5 }}
    //         onClick={() => onClick('openReplaceMake', t)}
    //       >
    //         {t.openType === 1 ? '开通代煎' : '代煎选项设置'}
    //       </Button>
    //     )
    //   },
    // },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '10em',
      render: function ActionBar(_, t): ReactElement {
        return (
          <Space>
            <a
              onClick={() => onClick('settings', t)}
              style={{ color: theme.tc2 }}
            >
              <SettingOutlined
                style={{
                  color: theme.c1,
                  marginRight: 4,
                  fontSize: '0.875rem',
                }}
              />
              设置
            </a>
            <a onClick={() => onClick('detail', t)}>查看详情 </a>
          </Space>
        )
      },
    },
  ]
}

export const orderColumns = (
  onClick: (t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // render: function tenantCategory(_, t) {
    //   return (
    //     <a onClick={() => onClick(t)}>查看详情 </a>
    //   )
    // },
    {
      title: '机构ID',
      dataIndex: 'tenantId',
      key: 'tenantId',
      align: 'center',
      width: '6rem',
    },
    {
      title: '订单号',
      dataIndex: 'id',
      key: 'id',
      width: '12rem',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '机构名称',
      dataIndex: 'tenantName',
      key: 'tenantName',
      width: '12rem',
      align: 'center',
      ellipsis: true,
      render: function tenantName(_, t) {
        return t?.tenantName ? (
          <Tooltip title={t.tenantName}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'center',
              }}
            >
              {t.tenantName}
            </div>
          </Tooltip>
        ) : (
          '-'
        )
      },
    },
    {
      title: '合作平台',
      dataIndex: 'platformName',
      key: 'platformName',
      width: '12rem',
      align: 'center',
      ellipsis: true,
      render: function platformName(_, t) {
        return t?.platformName ? (
            <Tooltip title={t.platformName}>
              <div
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                  }}
              >
                {t.platformName}
              </div>
            </Tooltip>
        ) : (
            '-'
        )
      },
    },
    {
      title: '所在区域',
      dataIndex: 'regionStr',
      key: 'regionStr',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      render: function regionStr(_, t) {
        return t?.regionStr ? (
          <Tooltip title={t.regionStr}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'center',
              }}
            >
              {t.regionStr}
            </div>
          </Tooltip>
        ) : (
          '-'
        )
      },
    },
    {
      title: '产品类型',
      key: 'productName',
      dataIndex: 'productName',
      width: '8rem',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '时长/次数',
      dataIndex: 'durationNumStr',
      key: 'durationNumStr',
      width: '6rem',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '单价',
      dataIndex: 'price',
      key: 'price',
      width: '6rem',
      align: 'center',
      ellipsis: true,
      render: function tenantCategory(_, t) {
        return t.price.toFixed(2)
      },
    },
    {
      title: '折扣',
      dataIndex: 'discountNum',
      key: 'discountNum',
      width: '6rem',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '实收金额',
      dataIndex: 'amount',
      key: 'amount',
      width: '6rem',
      align: 'center',
      ellipsis: true,
      render: (_, t) => {
        return t.amount.toFixed(2)
      },
    },
    {
      title: '支付类型',
      dataIndex: 'productName',
      key: 'productName',
      align: 'center',
      ellipsis: true,
      width: '8rem',
    },
    {
      title: '起始时间',
      dataIndex: 'serveStartTime',
      key: 'serveStartTime',
      width: '6rem',
      align: 'center',
      ellipsis: true,
      render: (_, t) => {
        return t.serveStartTime
          ? moment(t.serveStartTime)?.format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '终止时间',
      dataIndex: 'serveEndTime',
      key: 'serveEndTime',
      width: '6rem',
      align: 'center',
      ellipsis: true,
      render: (_, t) => {
        return t.serveEndTime
          ? moment(t.serveEndTime)?.format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '备注',
      key: 'remark',
      dataIndex: 'remark',
      align: 'center',
      ellipsis: true,
      width: '10rem',
      render: function regionStr(_, t) {
        return t?.remark ? (
          <Tooltip title={t.remark}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'center',
              }}
            >
              {t.remark}
            </div>
          </Tooltip>
        ) : (
          '-'
        )
      },
    },
    {
      title: '发票邮箱地址',
      key: 'email',
      dataIndex: 'email',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.email ? t.email : '-'
      },
    },

    {
      title: '企业抬头',
      key: 'companyName',
      dataIndex: 'companyName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.companyName ? t.companyName : '-'
      },
    },

    {
      title: '企业税号',
      key: 'taxNo',
      dataIndex: 'taxNo',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.taxNo ? t.taxNo : '-'
      },
    },
    {
      title: '创建人',
      key: 'createUserName',
      dataIndex: 'createUserName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.createUserName ? t.createUserName : '-'
      },
    },
    {
      title: '修改人',
      key: 'updateUserName',
      dataIndex: 'updateUserName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.updateUserName ? t.updateUserName : '-'
      },
    },
    {
      title: '创建时间',
      key: 'createTime',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
    },
    {
      title: '修改时间',
      key: 'updateTime',
      dataIndex: 'updateTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.updateTime ? t.updateTime : '-'
      },
    },
  ]
}
